import { useAppNavigation } from "src/contexts/AppNavigationContext";
import React, { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "src/constants/fontAwesomeIcons";
import { INavItem } from "..";
import { Tooltip } from "src/components/Tooltip";
import { useTheme } from "../../../contexts/ThemeContext";
import "./DrawerItem.scss";

interface IDrawerItemProps {
    navItem: INavItem;
}

const DrawerItem: FC<IDrawerItemProps> = ({ navItem }) => {
    const { isOpen, closeMobileDrawer } = useAppNavigation();
    const location = useLocation().pathname;
    const { light } = useTheme();

    const handleOnClickEvent: React.MouseEventHandler<HTMLElement> = (
        event
    ) => {
        const container = event.currentTarget;
        const ripple = document.createElement("span");
        ripple.className = "ripple";

        const rect = container.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        ripple.style.width = ripple.style.height = `${size * 2}px`;

        const x = event.clientX - rect.left - size;
        const y = event.clientY - rect.top - size;

        ripple.style.left = `${x}px`;
        ripple.style.top = `${y}px`;

        container.appendChild(ripple);

        // Clean up after animation
        setTimeout(() => {
            ripple.remove();
        }, 1400);

        if (
            navItem.url &&
            event.button === 0 &&
            !event.metaKey &&
            !event.ctrlKey &&
            !event.shiftKey &&
            !event.altKey
        ) {
            closeMobileDrawer();
        }
    };

    const isActive = () => {
        if (
            navItem.url?.toLowerCase() === location?.toLowerCase() &&
            navItem.title !== "Back"
        ) {
            return true;
        }

        return false;
    };

    const content = <>
        {/* Icon */}
        <div className="item-icon">
            {navItem.icon && <FontAwesomeIcon icon={navItem.icon} fixedWidth />}
        </div>

        {/* Title */}
        <div
            className="item-title"
            style={{ display: isOpen ? "block" : "none" }}
        >
            <span className="item-container-title">{navItem.title}</span>
        </div>
    </>;
    const style = {
        backgroundColor: isActive()
            ? light
                ? "rgba(234, 234, 234)"
                : "rgba(255, 255, 255, 0.15)"
            : "",
    };
    const drawerItem = navItem.url ? (
        <Link
            className="item-container-transition item-container"
            style={style}
            to={navItem.url}
            target={navItem.target}
            rel={navItem.target === "_blank" ? "noopener noreferrer" : undefined}
            onClick={handleOnClickEvent}
        >
            {content}
        </Link>
    ) : (
        <button
            type="button"
            className="item-container-transition item-container drawer-action"
            style={style}
            onClick={handleOnClickEvent}
        >
            {content}
        </button>
    );

    return (
        <Tooltip
            asChild
            content={!isOpen ? navItem.title : undefined}
            position="right"
            className="drawer-item-tooltip-trigger"
        >
            {drawerItem}
        </Tooltip>
    );
};

export default DrawerItem;
